import { connect } from 'react-redux';

import decorate from '../../../utils/decorate';

import AnonymousTab from './AnonymousTab.jsx';

function mapStateToProps(state) {
    let data = state.user.get('data');

    return {
    };
}

export default decorate(
    connect(mapStateToProps),
    AnonymousTab
);
